/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Protein_Supplement_NoInputs */

const en_us2_protein_supplement_no = /** @type {(inputs: Protein_Supplement_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const pt_br2_protein_supplement_no = /** @type {(inputs: Protein_Supplement_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não`)
};

const es_419_protein_supplement_no = /** @type {(inputs: Protein_Supplement_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const pt_pt2_protein_supplement_no = /** @type {(inputs: Protein_Supplement_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não`)
};

const fr_fr2_protein_supplement_no = /** @type {(inputs: Protein_Supplement_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non`)
};

const de_de2_protein_supplement_no = /** @type {(inputs: Protein_Supplement_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein`)
};

const it_it2_protein_supplement_no = /** @type {(inputs: Protein_Supplement_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

/**
* | output |
* | --- |
* | "No" |
*
* @param {Protein_Supplement_NoInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const protein_supplement_no = /** @type {((inputs?: Protein_Supplement_NoInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Protein_Supplement_NoInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_protein_supplement_no(inputs)
	if (locale === "es-419") return es_419_protein_supplement_no(inputs)
	if (locale === "pt-PT") return pt_pt2_protein_supplement_no(inputs)
	if (locale === "fr-FR") return fr_fr2_protein_supplement_no(inputs)
	if (locale === "de-DE") return de_de2_protein_supplement_no(inputs)
	if (locale === "it-IT") return it_it2_protein_supplement_no(inputs)
	return en_us2_protein_supplement_no(inputs)
});
export { protein_supplement_no as "protein_supplement.no" }